import { Component, OnInit, ElementRef, Renderer, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml} from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environment';
import { StoreService } from '../../services/store.service';
import { UserService } from '../../services/user.service';

import { incomingCards, staggeredCards, CartOverlay, parentCategories, childCategories, zFade } from '../animations';

import { Currency } from '../../models/currency';
import { Category } from '../../models/category';
import { Item } from '../../models/item';
import { Filter } from '../../models/filter.constructor';

@Component({
  selector: 'categories',
  templateUrl: './categories.component.html',
  animations: [ incomingCards, staggeredCards, CartOverlay, parentCategories, childCategories, zFade ]
})
export class CategoryComponent implements OnInit {

	@Output() addedItemtoCart:EventEmitter<string> = new EventEmitter();

	@Input() resetCart = false;
	@Input() hideHeader = false;
	@Input() showFilters:any = true;
	@Input() staggerAnimate = true;

	items: Item;
	allitems: Item;
	header: any;
	title: string;
	headerAlign: any;
	subtitle: string;
	headerHeight: any;
	subtitleLink: string;
	cart: any[];
	itemsInCart: any[];
	custom: any;
	total: number;
	cartItems: any;
	customizer: any;
	currencyOpen: any;
	showCards = -1;
	showCats = -1;
	searching: boolean;
	flashCart: boolean;
	itemsOnPage: number;
	subtitleIcon: string;
	viewCategory: string;	
	loadingCart: boolean;
	numberOfItems: any;
	filtersActive: boolean;
	categoriescount: number;
	selectedCategory: string;
	loadedCats = false;

	childIndex = 0;
	itemOnPage = 0;
	selectedItem = 0;
	selectedImage = 0;
	loadingItems = 9;
	itemsShownPerPage = 0;
	hasProducts = null;
	showItemDetails = false;
	loadingItemDetails = false;
	displayParentCategories = true;
	displayChildCategories = false;
	enableCurrencySelector = false;

	hideOwned = false;

	currency: Currency;
	currencies: Currency;
	categories: Category;
	parentcategories: Category;
	
	itemquery = new Filter();

	constructor(private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router,
				private cdr: ChangeDetectorRef,
				private element: ElementRef,
  				private renderer: Renderer) {

	}



	/**
	* Page Handling
	**/

	ngOnChanges(changes) {
		if (changes.resetCart) {
			this.getCart();
		}
	}

	updateCategory( category ) {
		this.itemquery.category = category.id;
		this.refreshItems();
	}

	clearCategory() {
		this.itemquery.category = 0;
		this.refreshItems();
	}

	updateChildCategory( category ) {
		this.refreshItems();
	}

	areFiltersActive( type ) {
		if ( this[type+'query'].sort != 'ASC' ) {
			return true;
		} else if ( this[type+'query'].category != null ) {
			return true;
		} else if ( this[type+'query'].filterItems != null ) {
			return true;
		} else {
			return false;
		}
	}

	refreshItems() {
		Promise.resolve( this.storeService.getItems( this.itemquery ) ).then( (cats) => {
			this.allitems = cats;
			setTimeout( () => { this.hasProducts = true; this.stagger(90); }, 500);
		});
		Promise.resolve( this.storeService.countItems(this.itemquery) ).then( (count) => {
			this.numberOfItems = count;
			setTimeout( () => { this.stagger(90); }, 200);
		});
	}

	createRange(number) {
		var items: number[] = [];
		for(var i = 1; i <= number; i++) { items.push(i); }		
		return items;
	}


	/**
	* Cart Handling
	**/
	

	addToCart(item, redirect?) {
		if ( item.limit == 0 || item.limit > item.owns ) {
			if ( this.inCart( item.id ) ) {
				this.router.navigate(['/checkout']);
			} else {
				this.addedItemtoCart.emit(item);
				this.storeService.addItem(item.id);
				this.updateCartButton();
				this.getCart();
			}
		}
	}

	inCart( id ) {
		let incart = false;
		if ( this.cart.indexOf( id ) > -1 ) {
			incart = true;
		} else {
			// console.log(this.itemsInCart);
			if ( this.itemsInCart && this.itemsInCart.indexOf( id ) > -1 ) { 
				incart = true;
			}
		}
		return incart;
	}

	
	getCart() {
		this.cart = this.storeService.getCartContents();
		this.custom = this.storeService.getItemContents();
		Promise.resolve( this.storeService.getCartItemIDs() ).then((cartitems) => {
			this.itemsInCart = cartitems;
			this.updateCartButton();
		});
	}
	
	getTotal() {
		Promise.resolve(this.storeService.getCustomizerTotal()).then(t => 
			this.total = t
		);
	}

	updateCartButton() {
		this.flashCart = true;
		setTimeout( () => { this.flashCart = false;  }, 5000);
	}

	toggleItem(item) {
		if ( this.isSelected(item) ) {
			this.subtractItem(item);
		} else {
			this.addItem(item);
		}
	}

	hideDetails() {
		this.showItemDetails= false;
	}

	addItem(item) {
		this.storeService.addItem(item.id);
	}

	subtractItem(item) {
		this.storeService.removeItem(item.id);
	}

	isSelected(item) {
		let found = false;
		for (var i = this.cartItems.length - 1; i >= 0; i--) {
			if (this.cartItems[i].id == item.id) 
				found = true;
		}
		return found;
	}


	nextItem() {
		this.selectedImage = 0; // < this.numberOfItems-1
		this.selectedItem = (this.selectedItem < this.numberOfItems-1) ? this.selectedItem+1 : this.selectedItem;
	}

	prevItem() {
		this.selectedImage = 0;
		this.selectedItem = (this.selectedItem > 0) ? this.selectedItem-1 : 0;
	}



	/**
	* Currency Handling
	**/
	getCurrencies() {
		if ( environment.currencies ) {
			Promise.resolve( this.storeService.getCurrencies() ).then((c) => {
				this.currencies = c;
			});

			Promise.resolve( this.storeService.getCurrency() ).then((c) => {
				this.currency = c[0];
			});

			Promise.resolve(this.storeService.enableCurrencySelector()).then((bool) => {
				this.enableCurrencySelector = bool;
			});
		}
	}
	
	changeCurrency(currenc) {
		this.currency = currenc;
		this.currencyOpen = -1;
		this.storeService.changeCurrency(currenc);
	}




	/**
	* Animations
	**/
	addItemsToPage() {
		this.itemsOnPage = this.itemsOnPage+6;
	}


	/**
	* Effects / Animations
	**/
	stagger(t = 90) {
		if (this.showCards < this.numberOfItems) {
			this.showCards = this.showCards + 1;
			setTimeout( () => { this.stagger(t); }, t);
		} else { 
			this.showCards = this.numberOfItems;
		}
	}

	staggerCats(t = 90) {
		if (this.showCats < this.categoriescount) {
			this.showCats = this.showCats+1;
			setTimeout( () => { this.staggerCats(t); }, t);
		} else {
			this.showCats = this.categoriescount;
		}
	}


	/**
	* ON with the show
	**/
	ngOnInit() {

  		this.title = 'Items';
		this.headerHeight = '350px';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/video/video.jpg") 10%' );
		this.subtitle = 'Equip your character for survival';
		this.itemquery.sort = 'asc';
		this.itemquery.category	= null;

		/**
		* Get Details for this particular Item
		* Accept URL Parameter /:id
		**/
		this.router.events
			.filter(event => event instanceof NavigationEnd)
			.map(() => this.router.routerState.root)
			.subscribe((event) => {
				this.viewCategory = this.route.snapshot.params['id'];
			});

		// this.cart = this.storeService.getCartContents();
		// this.customizer = this.storeService.getCustomizerContents();

		this.getCart();

		Promise.resolve( this.storeService.getParentCategories() ).then( (cats) => {
			this.parentcategories = cats;
			this.storeService.countParentCategories().subscribe((count) => { 
				this.categoriescount = count
			});
		});

		Promise.resolve( this.storeService.getCategories() ).then( (cats) => {
			this.loadedCats = true;
			this.categories = cats;
			setTimeout( () => { this.staggerCats(200); }, 300);
		});

		this.refreshItems();
		this.getCurrencies();

		this.hideOwned = this.storeService.ownedHidden();

	}

}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/categories/categories.component.ts